import { isGlobalFeatureEnabled } from "owa-feature-flags";

export function isOfflineBootAvailable(): boolean {
    return isGlobalFeatureEnabled("fwk-offline-boot");
}
